var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { indicator: _vm.indicator }, attrs: { id: "notifications" } },
    [
      _c(
        "q-btn-dropdown",
        {
          attrs: { icon: "fa fa-bell" },
          on: {
            click: function($event) {
              _vm.clearIndicator()
            }
          }
        },
        [
          _c(
            "q-list",
            { attrs: { link: "", separator: "" } },
            [
              _vm.notifications.length == 0
                ? _c(
                    "q-item",
                    {
                      directives: [
                        { name: "close-overlay", rawName: "v-close-overlay" }
                      ]
                    },
                    [
                      _c("q-item-side", {
                        attrs: {
                          inverted: "",
                          icon: "error outline",
                          color: "red",
                          "text-color": "white"
                        }
                      }),
                      _c(
                        "q-item-main",
                        [
                          _c("q-item-tile", { attrs: { label: "" } }, [
                            _vm._v("No Notifications Found.")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._l(_vm.notifications, function(item, i) {
                return _c(
                  "q-item",
                  {
                    directives: [
                      { name: "close-overlay", rawName: "v-close-overlay" }
                    ],
                    key: i,
                    attrs: { tag: "label" },
                    nativeOn: {
                      click: function($event) {
                        _vm.openNotification(item)
                      }
                    }
                  },
                  [
                    _c(
                      "q-item-side",
                      [
                        _c("q-icon", {
                          attrs: { name: "info outline", color: "blue" }
                        })
                      ],
                      1
                    ),
                    _c(
                      "q-item-main",
                      [
                        _c("q-item-tile", { attrs: { label: "" } }, [
                          _vm._v(_vm._s(item.MESSAGE))
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              })
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }